import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import groupBy from 'lodash/groupBy';

import ButtonShowcase from './ButtonShowcase';
import { FILTERKEYS } from './constants';

const ButtonsList = ({ content }) => {
  const dataGroup = groupBy(content, 'type');
  const dataKeys = Object.keys(dataGroup);

  return (
    <Fragment>
      {dataKeys.map(group => (
        <section key={`${group}-button-group`}>
          <h2 className="h2 page-subtitle">{FILTERKEYS[group]}</h2>
          <ul className="showcase-list">
            {
              dataGroup[group].map(group => (
                group.previews.map((buttons, i) => (
                  <li key={`button-${group.type}-showcase-${i}`}>
                    <ButtonShowcase {...buttons} />
                  </li>
                ))
              ))
            }
          </ul>
        </section>
      ))}
    </Fragment>
  );
};

ButtonsList.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object)
};

ButtonsList.displayName = 'ButtonsList';

export default ButtonsList;



// WEBPACK FOOTER //
// ./src/containers/elements/Buttons/ButtonsList.js